// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"d5b57245","453":"08bc2b5e"}[chunkId] + ".chunk.js";
};